module.exports = "/static/img/ai-background-hero.png?4766073206054871e7a3803c81a73bee";